import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { common } from './commonReducer'
import { addressData } from './addressReducer'
import { couponData } from './couponReducer'
import { deliveryData } from './deliveryReducer'
import { mallBanner } from './mallBannerReducer'
import { mallHotSale } from './mallHotSaleReducer'
import { mallCatalogs } from './mallCatalogsReducer'
import { mallHomeProducts } from './mallHomeProductsReducer'
import { mallProductList } from './mallProductListReducer'
import { mallProductDetails } from './mallProductDetailsReducer'
import { mallCart } from './mallCartReducer'
import { mallOrderList } from './mallOrderListReducer'
import { mallOrderConfirm } from './mallOrderConfirmReducer'
// import { mallBanner } from './mallBannerReducer'
import { integralList } from './integralListReducer'

const rootReducers = combineReducers({
  routing: routerReducer,
  common,
  addressData,
  couponData,
  // delivery
  deliveryData,
  // mall
  mallBanner,
  mallHotSale,
  mallCatalogs,
  mallHomeProducts,
  mallProductList,
  mallProductDetails,
  mallOrderConfirm,
  mallOrderList,
  mallCart,
  // mallBanner, // 有问题
  // integral
  integralList
})

export default rootReducers
